import React, { CSSProperties } from 'react';

import { bemCssModules } from '@utils';

import style from './Preloader.scss';

const cn = bemCssModules(style, 'Preloader');

export type TPreloader = {
  color?: string;
  size?: number;
  isLoading?: boolean;
  classNames?: Partial<{
    svg: string;
    circle: string;
  }>;
};

const Preloader: CustomFC<TPreloader> = ({
  className,
  classNames,
  color = 'var(--color-action-active)',
  size = 32,
}) => {
  return (
    <div className={cn(null, [className])} style={{ '--size': `${size}px` } as CSSProperties}>
      <svg className={cn('circular', [classNames?.svg])} viewBox="25 25 50 50">
        <circle
          className={cn('path', [classNames?.circle])}
          cx="50"
          cy="50"
          r="20"
          fill="none"
          strokeWidth="4"
          strokeMiterlimit="10"
          stroke={color || 'var(--color-main-bg)'}
        />
      </svg>
    </div>
  );
};

export default Preloader;
